import { Button, Input, Modal } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Style } from './style';
import { useProjectSources } from './hook';
import NewItem from './components/NewItem';
import ItemsList from './components/ItemsList';
import { useTranslation } from 'react-i18next';
import EmptyState from './components/EmptyState';
import SelectedItem from './components/SelectedItem';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { ModalHeader } from 'datastake-daf/dist/components';

export default function ProjectSources({ user, conf = {} }) {
  const { t } = useTranslation();
  const {
    form,
    mode,
    search,
    onDelete,
    selected,
    setSearch,
    selectedItem,
    setSelectedItem,
    onChangeDisable,
    shareInfoOptions,
    onChangeShareInfo,
    onClickNew,
    onCloseNew,
    inputs,
    onAddNew,
    onChangeStatus,
    onChangeSourceName,
    sorted,
    mappedItems,
  } = useProjectSources({ user, conf, t });

  return (
    <Style className="form-edit">
      <div className="main-form document-form project-form">
        <div className={formatClassname(['edit-form-body', 'documents-layout'])}>
          <div className="edit-form-header px-md pt-3">
            <h1>{form.label}</h1>
          </div>
          <div className="actions px-md">
            <div>
              <Input
                prefix={<SearchOutlined />}
                value={search}
                placeholder={t('Search')}
                size="large"
                onChange={(e) => setSearch(e.target.value)} />
            </div>
            <div className="btn-cont">
              <Button
                onClick={onClickNew}
                type="primary"
                size="large"
                icon={<PlusOutlined style={{ fontSize: 16 }} />}
                className="px-md"
              >
                {t('Add')}
              </Button>
            </div>
          </div>
          <div className="main-container">
            <ItemsList
              items={sorted}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
            {selected ? (
              <SelectedItem
                conf={conf}
                onChangeShareInfo={onChangeShareInfo}
                shareInfoOptions={shareInfoOptions}
                onChangeDisable={onChangeDisable}
                item={selected}
                onDelete={onDelete}
                onChangeStatus={onChangeStatus}
                onChangeSourceName={onChangeSourceName}
              />
            ) : (
              <EmptyState onCreate={onClickNew} conf={conf} />
            )}
          </div>
        </div>
      </div>
      <Modal
        open={mode === 'new'}
        title={<ModalHeader title={t(conf.group === 'informationSources' ? 'New Information Source' : 'New Client')} />}
        footer={null}
        destroyOnClose
        onCancel={onCloseNew}
      >
        <NewItem
          onClose={onCloseNew}
          inputs={inputs}
          group={conf.group}
          onConfirm={onAddNew}
          preSelected={(mappedItems || []).map((item => item.authorId))}
        />
      </Modal>
    </Style >
  );
}
